<div class="">
    <div class="page-content">
        <!-- <h2 class="heading1">Heading</h2> -->
        <h3 class="heading3">Select Item to Copy</h3>
        <div class="mt-4">
            <div class="col-md-12 tabledesign">
                <table mat-table [dataSource]="dataSource">
                
                  <!-- Column -->
                  <ng-container matColumnDef="base_document">
                    <th mat-header-cell *matHeaderCellDef>Base Document</th>
                    <td mat-cell *matCellDef="let row">
                      <span class="">{{row.base_document}}</span>
                    </td>
                  </ng-container>

                  <!-- Column -->
                  <ng-container matColumnDef="item_no">
                    <th mat-header-cell *matHeaderCellDef>Item No.</th>
                    <td mat-cell *matCellDef="let row">
                      <span class="">{{row.item_no}}</span>
                    </td>
                  </ng-container>

                  <!-- Column -->
                  <ng-container matColumnDef="bp_catalog_no">
                    <th mat-header-cell *matHeaderCellDef>BP Catalog No.</th>
                    <td mat-cell *matCellDef="let row">
                      <span class="">{{row.bp_catalog_no}}</span>
                    </td>
                  </ng-container>

                  <!-- Column -->
                  <ng-container matColumnDef="item_desc">
                    <th mat-header-cell *matHeaderCellDef>Item Description</th>
                    <td mat-cell *matCellDef="let row">
                      <span class="">{{row.item_desc}}</span>
                    </td>
                  </ng-container>

                  <!-- Column -->
                  <ng-container matColumnDef="qty">
                    <th mat-header-cell *matHeaderCellDef>Qty.</th>
                    <td mat-cell *matCellDef="let row">
                        <mat-form-field class="field-bottom-0 mt-2 wp-100" appearance="outline">
                            <input type="text" matInput>
                        </mat-form-field>
                    </td>
                  </ng-container>

                  <!-- Column -->
                  <ng-container matColumnDef="unit_price">
                    <th mat-header-cell *matHeaderCellDef>Unit Price</th>
                    <td mat-cell *matCellDef="let row">
                        <mat-form-field class="field-bottom-0 mt-2 wp-100" appearance="outline">
                            <input type="text" matInput>
                        </mat-form-field>
                    </td>
                  </ng-container>

                  <!-- Column -->
                  <ng-container matColumnDef="discount">
                    <th mat-header-cell *matHeaderCellDef>Discount %</th>
                    <td mat-cell *matCellDef="let row">
                        <mat-form-field class="field-bottom-0 mt-2 wp-100" appearance="outline">
                            <input type="text" matInput>
                        </mat-form-field>
                    </td>
                  </ng-container>
                  
                  <!-- Column -->
                  <ng-container matColumnDef="total">
                    <th mat-header-cell *matHeaderCellDef>Total</th>
                    <td mat-cell *matCellDef="let row">
                        <mat-form-field class="field-bottom-0 mt-2 wp-100" appearance="outline">
                            <input type="text" matInput>
                        </mat-form-field>
                    </td>
                  </ng-container>

                  <!-- Column -->
                  <ng-container matColumnDef="departments">
                    <th mat-header-cell *matHeaderCellDef>department </th>
                    <td mat-cell *matCellDef="let row">
                      <span class="">{{row.departments}}</span>
                    </td>
                  </ng-container>

                  <!-- Column -->
                  <ng-container matColumnDef="line_of_business">
                    <th mat-header-cell *matHeaderCellDef>Line of Business</th>
                    <td mat-cell *matCellDef="let row">
                      <span class="">{{row.line_of_business}}</span>
                    </td>
                  </ng-container>

                  <!-- Column -->
                  <ng-container matColumnDef="dimension_3">
                    <th mat-header-cell *matHeaderCellDef>Dimension 3</th>
                    <td mat-cell *matCellDef="let row">
                      <span class="">{{row.dimension_3}}</span>
                    </td>
                  </ng-container>

                  <!-- Column -->
                  <ng-container matColumnDef="dimension_4">
                    <th mat-header-cell *matHeaderCellDef>Dimension 4</th>
                    <td mat-cell *matCellDef="let row">
                      <span class="">{{row.dimension_4}}</span>
                    </td>
                  </ng-container>

                  <!-- Column -->
                  <ng-container matColumnDef="dimension_5">
                    <th mat-header-cell *matHeaderCellDef>Dimension 5</th>
                    <td mat-cell *matCellDef="let row">
                      <span class="">{{row.dimension_5}}</span>
                    </td>
                  </ng-container>

                  <!-- Column -->
                  <ng-container matColumnDef="uom_code">
                    <th mat-header-cell *matHeaderCellDef>UoM Code</th>
                    <td mat-cell *matCellDef="let row">
                      <span class="">{{row.uom_code}}</span>
                    </td>
                  </ng-container>

                  <!-- Column -->
                  <ng-container matColumnDef="unit_name">
                    <th mat-header-cell *matHeaderCellDef>Unit Name</th>
                    <td mat-cell *matCellDef="let row">
                      <span class="">{{row.unit_name}}</span>
                    </td>
                  </ng-container>

                  <!-- Column -->
                  <ng-container matColumnDef="qty_inventory">
                    <th mat-header-cell *matHeaderCellDef>Qty. (Inventory UoM)</th>
                    <td mat-cell *matCellDef="let row">
                      <span class="">{{row.qty_inventory}}</span>
                    </td>
                  </ng-container>

                  <!-- Column -->
                  <ng-container matColumnDef="branch">
                    <th mat-header-cell *matHeaderCellDef>Branch</th>
                    <td mat-cell *matCellDef="let row">
                      <span class="">{{row.branch}}</span>
                    </td>
                  </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
        </div>
    </div>
    <div class="mt-2 footer">
        <div class="">
            <button #buttonSave mat-raised-button color="primary" class="me-1">Finish</button>
            <button class="me-2" #buttonCancel mat-raised-button>Cancel</button>
        </div>
    </div>
</div>